(function() {
  function initializeVideoControls(container) {
    container = container || document;

    container.querySelectorAll('.vr-video-play-button').forEach(function(button) {
      if (button.dataset.vrInitialized === 'true') return;
      button.dataset.vrInitialized = 'true';

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var videoContainer = this.closest('.vr-video');
        var video = videoContainer ? videoContainer.querySelector('video') : null;
        if (video) {
          if (video.paused) {
            video.play();
            video.classList.remove('video-off');
            videoContainer.classList.add('video-playing');
            this.classList.add('hidden');
          } else {
            video.pause();
            video.classList.add('video-off');
            videoContainer.classList.remove('video-playing');
            this.classList.remove('hidden');
          }
        }
      });
    });

    container.querySelectorAll('.vr-video video').forEach(function(video) {
      if (video.dataset.vrInitialized === 'true') return;
      video.dataset.vrInitialized = 'true';

      video.addEventListener('play', function() {
        var container = this.closest('.vr-video');
        var button = container ? container.querySelector('.vr-video-play-button') : null;
        if (container) container.classList.add('video-playing');
        if (button) button.classList.add('hidden');
      });
      video.addEventListener('pause', function() {
        var container = this.closest('.vr-video');
        var button = container ? container.querySelector('.vr-video-play-button') : null;
        if (container) container.classList.remove('video-playing');
        if (button) button.classList.remove('hidden');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeVideoControls();
    });
  } else {
    initializeVideoControls();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target;
    if (section.querySelector('.vr-video')) {
      setTimeout(function() {
        initializeVideoControls(section);
      }, 100);
    }
  });
})();
